export { default } from './BlogDetailsHero';
